<ng-template #popContent ngShow="!detectLocationAction">
  <div class="text-center popovercontent" *ngIf="!detectLocationAction">
    <h4 class="mt-2 mb-2">Change Delivery City</h4>
    <div class="row">
      <div class="col-md-12">
        <div class="input-group mb-3 has-search pr-2 pl-2">
          <span class="fa fa-search form-control-feedback"></span>
          <input type="text" [options]="options" ngx-google-places-autocomplete  #placesRef="ngx-places" 
           (onAddressChange)="handleAddressChange($event)" class="form-control"  placeholder="Search" />
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="detectLocation()"
            >
              <i class="fa fa-location-arrow" *ngIf="!loadingAction"></i>
              <i class="fa fa-spin fa-spinner" *ngIf="loadingAction"></i> Detect
            </button>
            <!-- <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="openAddressModel()"
            >
              <i class="fa fa-location-arrow" *ngIf="!loadingAction"></i>
              <i class="fa fa-spin fa-spinner" *ngIf="loadingAction"></i> New Address
            </button> -->
          </div>
          <!-- <div class="hDfwhm" (click)="detectLocation()"><i height="18px" width="18px" class="djDbO"></i><div class="fQsVyi">Use current location</div></div> -->
        </div>
      </div>
    </div>
    <div class="savedaddress ScrollStyle" *ngIf="addressList && addressList.length >0">
      <div style="color: #aeaeae">Saved Addresses</div>
      <div *ngFor="let address of addressList; let i = index">
      <div class="address" (click)="updateLocation(address)">
        <div><!--<i class="fa fa-home pr-2"></i>--> 
          <span *ngIf="address.addressType == 'Home'"><img src="assets/images/icon/home.png" style="width:15px; height:15px;margin-right: 10px;"></span>
            <span *ngIf="address.addressType == 'Office'"><img src="assets/images/icon/business-and-trade.png" style="width:15px; height:15px;margin-right: 10px;"></span>
            <span *ngIf="address.addressType != 'Home' && address.addressType != 'Office'"><img src="assets/images/icon/user.png" style="width:40px; height:20px;margin-left: -15px;"></span>{{ address.addressType }}</div>
        <div class="addresscontent pl-4">
          
         {{ address.doorNo }}, {{ address.landmark }}, {{ address.locality }}, {{ address.city }}, {{ address.state }}, {{ address.pincode }}
         
        </div>
      </div>
    </div>
    </div>
  </div>
  <!-- <div class="text-center popovercontent" *ngIf="detectLocationAction">
    <div class="float-left backlink">
      <a (click)="detectLocationAction = false"
        ><i class="fa fa-chevron-left"></i> Back</a
      >
    </div>
    <br />
    <div>
      <img src="assets/images/no-delivery.jpg" />
      <div class="nodelivery-header">Oh No!</div>
      <div class="nodelivery-subheader">We are not yet in</div>
      <div class="nodelivery-content">
        - We are currently delivering in select parts of -
      </div>
      <div class="mb-4 deliverycities">
        <a>Hyderabad</a>, <a>Bangalore</a>, <a>Hyderabad</a>, <a>Bangalore</a>,
        <a>Hyderabad</a>, <a>Bangalore</a>
      </div>
    </div>
  </div> -->
</ng-template>
<div class="tot-set-location" *ngIf="!isLocation">
  <div
    class="set-location"
    [ngbPopover]="popContent"
    [autoClose]="'outside'"
    [placement]="'bottom-relative'"
    
  >
  <div #myDiv ></div>
  <div style="display: inline-flex;">
  <div class="contact-icon">
    <i class="fa fa-map-marker" aria-hidden="true"></i>
  </div>
    <div class="addressBlock">
    <div class="web-view addressDetail" >{{ divLocation }} </div>
  </div>
    <div><i class="arrow down"></i></div>
  </div>
  </div>

  
</div>

<!-- for address modal -->
<div
  class="modal"
  id="myModal"
  [style.display]="isAddressSelected ? 'block' : 'none'"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content quick-view-modal">
      <!-- <div class="modal-header">
        <h4 class="col-11 modal-title text-center">
          Add New Delivery Addressss
        </h4>
        <button type="button" class="close" (click)="closeAddressModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->
      <div class="modal-body">
        <button type="button" class="close" (click)="closeAddressModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="address-form">
          <div class="address-header text-center">Add New Delivery Address</div>
          <div class="address-subheader text-center">
            Please enter the accurate address, it will help us to serve you
            better
          </div>
          <div class="p-2">
            <form>
              <div class="form-row">
                <div class="form-group col-md-12 col-sm-12">
                  <label for="inputEmail4">Area / Locality </label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="selectedAddress.locality"
                    name="locality"
                    id="inputEmail4"
                  />
                </div>
                <!-- <div class="col-md-3 col-sm-12">
                          <button class="btn btn-outline-secondary detectbutton"><i class="fa fa-location-arrow"></i> Detect</button>
                      </div> -->
              </div>
              <div class="detailssection">
                <!-- <div class="dropdown">
                          <label for="name">Name</label>
                          <div class="input-group mb-3">
                              <div ngbDropdown class="d-inline-block">
                                  <button class="btn btn-outline-secondary cstmbtn" id="dropdownBasic1" ngbDropdownToggle>{{selectedValue}}</button>
                                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <button ngbDropdownItem (click)="changeDropdownName('Mr')">Mr</button>
                                    <button ngbDropdownItem (click)="changeDropdownName('Mrs')">Mrs</button>
                                    <button ngbDropdownItem (click)="changeDropdownName('Miss')">Miss</button>
                                  </div>
                                </div>
                              <input type="text" class="form-control" aria-label="Text input with dropdown button">
                          </div>  
                      </div> -->

                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >Flat / House / Office No.</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="selectedAddress.doorNo"
                    name="flatNo"
                    id="flatNo"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1"
                    >Street / Society / Office Name
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="streetNo"
                    [(ngModel)]="selectedAddress.landmark"
                    name="streetNo"
                  />
                </div>
                <div class="form-group">
                  <label for="city">City</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="selectedAddress.city"
                    id="city"
                    name="city"
                  />
                </div>
                <div class="form-group">
                  <label for="state">State </label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="selectedAddress.state"
                    name="state"
                    id="state"
                  />
                </div>
                <div class="form-group">
                  <label for="state">PinCode </label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="selectedAddress.pincode"
                    id="pincode"
                    name="pincode"
                  />
                </div>
                <div class="form-group">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      [(ngModel)]="addressType"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="Home"
                    />
                    <label class="form-check-label" for="inlineRadio1"
                      >Home</label
                    >
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [(ngModel)]="addressType"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="Office"
                    />
                    <label class="form-check-label" for="inlineRadio2"
                      >Office</label
                    >
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [(ngModel)]="addressType"
                      name="inlineRadioOptions"
                      id="inlineRadio3"
                      value="Other"
                    />
                    <label class="form-check-label" for="inlineRadio3"
                      >Other</label
                    >
                  </div>
                </div>
                <div class="form-group" *ngIf="addressType == 'other'">
                  <input
                    type="text"
                    [(ngModel)]="addressType"
                    name="other"
                    class="form-control"
                    id="other"
                  />
                </div>

                <div class="text-center">
                  <button
                    type="button"
                    (click)="submitAddress()"
                    class="btn btn-solid mr-3"
                  >
                    Continue
                  </button>
                  <button
                    type="button"
                    (click)="closeAddressModal()"
                    class="btn btn-outline-secondary"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>